module.exports = __webpack_public_path__ + "img/12.9c50dc50.png";